import { render, staticRenderFns } from "./ContactBottom.vue?vue&type=template&id=818a7dc8&"
import script from "./ContactBottom.vue?vue&type=script&lang=js&"
export * from "./ContactBottom.vue?vue&type=script&lang=js&"
import style0 from "./ContactBottom.vue?vue&type=style&index=0&id=818a7dc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports